<template>
  <base-input :rules="internalRules" :errors="errors">
    <slot />
  </base-input>
</template>

<script>
import validatable from "@/mixins/validatable";
import BaseInput from "@/components/base/BaseInput";

export default {
  mixins: [validatable],
  components: {
    BaseInput,
  },
  props: {
    modelValue: [String, Number, Boolean],
  },
  methods: {
    reset() {
      this.isResetting = true;
      this.$emit("update:modelValue", null);
    },
  },
};
</script>
